import { defineComponent as _defineComponent } from 'vue'
interface Props {
	disabled?: boolean,
	loading?: boolean,
	text?: string,
	color?: string,
	to?: object,
	href?: string,
}



export default /*#__PURE__*/_defineComponent({
  __name: 'RmpTextBtn',
  props: {
    disabled: { type: Boolean },
    loading: { type: Boolean },
    text: null,
    color: { default: "primary" },
    to: null,
    href: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { disabled?: boolean, loading?: boolean, text?: string, color: string, to?: object, href: string };



return { __sfc: true,props }
}

})